import {Component, Input, OnInit} from '@angular/core';
import {HouseholdQuery} from '@core/state/household';
import { ModalController } from '@ionic/angular';
import { ModalContactFormComponent } from '../modal-contact-form/modal-contact-form.component';

@Component({
  selector: 'app-improved-cost',
  templateUrl: './improved-cost.component.html',
  styleUrls: ['./improved-cost.component.scss'],
})
export class ImprovedCostComponent implements OnInit {
  @Input() wizardComplete = false;
  household$ = this.householdQuery.select();

  constructor(
    private householdQuery: HouseholdQuery,
    public modalController: ModalController
  ) { }

  ngOnInit() {}
  

  async presentModal() {
    const modal = await this.modalController.create({
      component: ModalContactFormComponent,
      cssClass: 'app-modal-contact-form'
    });
    
    return await modal.present();
  }

}
